import { render, staticRenderFns } from "./FavouriteColours.vue?vue&type=template&id=709eeeb1"
import script from "./FavouriteColours.vue?vue&type=script&lang=js"
export * from "./FavouriteColours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports